// extracted by mini-css-extract-plugin
module.exports = {"langToggle":"langToggle_langToggle__1wO6V","eng":"langToggle_eng__3IpO6","kor":"langToggle_kor__2FjNV"};